var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',{attrs:{"elevation":"0"}},[_c('v-card-title',[_c('v-spacer'),_c('v-btn',{attrs:{"text":"","color":"primary"}},[_vm._v("nueva actividad")])],1),_c('v-card-text',[_c('v-data-table')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }